export default __webpack_public_path__ + "static/media/close-icon-thin.1ce0c6d4.svg";